import { InfoTip } from './InfoTip'
import type { MetricKey } from '../lib/metrics'
import './StatTile.css'

interface StatTileProps {
  label: string
  metric?: MetricKey        // renders an InfoTip when provided
  value: string             // pre-formatted ("+$124.50", "+1.2%", "14 up · 9 down")
  tone?: 'gain' | 'loss' | 'neutral'
  sub?: string              // small caption under the value
  emphasis?: boolean        // spec §5: the Excess tile is visually dominant
}

/** Verdict-tile primitive (spec §10) — picks, incubation header, tax reuse it. */
export function StatTile({ label, metric, value, tone = 'neutral', sub, emphasis }: StatTileProps) {
  return (
    <div className={`stat-tile${emphasis ? ' stat-tile--emphasis' : ''}`}>
      <span className="stat-tile-label caption">
        {label}
        {metric && <InfoTip metric={metric} />}
      </span>
      <span className={`stat-tile-value num stat-tile-value--${tone}`}>{value}</span>
      {sub && <span className="stat-tile-sub caption">{sub}</span>}
    </div>
  )
}
